module.exports = __webpack_public_path__ + "img/sin-promo.37a5e7f0.png";